// エントリポイント。旧 app/assets/javascripts/application.js の
// Sprockets マニフェストを import で再現している。読み込み順が重要:
// jQuery のグローバル公開 → jQuery プラグイン群 → アプリ固有 JS の順。
// require_tree 相当はアルファベット順で全ファイルを明示列挙する。

// ライブラリ(旧マニフェストの //= require 順)
import "./src/jquery-global";
import "./src/turbo-global";
import "./src/moment-global";
import "eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min";
import "bootstrap-daterangepicker/daterangepicker";
import "moment/locale/ja";
import "bootstrap/dist/js/bootstrap";
import "admin-lte/dist/js/adminlte";
import "./src/select2-init";
import "./src/select2_remote";
import "select2/dist/js/i18n/ja";
import "./vendor/jquery.autoKana";
import "./vendor/jquery.jpostal";
import "./src/jpostal_preserve_input";
import "@nathanvda/cocoon/cocoon";
import "./src/activestorage-init";
import "./src/drag_drop_upload";
import "./src/marked-global";

// Stimulus。jQuery / Select2 / Bootstrap / datetimepicker の後に起動する。
import "./controllers";

// PWA Service Worker 登録（未対応環境では no-op）。
import { registerServiceWorker } from "./pwa/register";
import { startOfflineSyncScheduler, handleLogoutBeforeFetch } from "./pwa/snapshot";
import { startOutboxFlushScheduler } from "./pwa/outbox";

startOutboxFlushScheduler();

registerServiceWorker().then(() => {
  startOfflineSyncScheduler();
});

document.addEventListener("turbo:before-fetch-request", (event) => {
  handleLogoutBeforeFetch(event);
});

// アプリ固有 JS(旧 require_tree . 相当。アルファベット順)
import "./src/charges";
import "./src/client_bank_transactions";
import "./src/client_bank_transactions_import";
import "./src/contact_imports";
import "./src/contact_label";
import "./src/contacts";
import "./src/csp_nonce";
import "./src/data_actions";
import "./src/depts";
import "./src/earning_imports";
import "./src/earnings";
import "./src/expense_imports";
import "./src/expenses";
import "./src/global_search";
import "./src/group/managements";
import "./src/groups";
import "./src/invoices";
import "./src/loading";
import "./src/magic_link_login";
import "./src/markdown_renderer";
import "./src/matter_financials";
import "./src/matter_imports";
import "./src/matter_users";
import "./src/matters";
import "./src/memo_imports";
import "./src/memos";
import "./src/messages";
import "./src/places";
import "./src/receipts";
import "./src/schedules";
import "./src/support_chat_widget";
import "./src/timer";
import "./src/users";
import "./src/wage";
import "./src/webhooks";

// 旧 application.js のインライン実装(Select2Cascade ほか)。
// Sprockets ではマニフェスト本文が最後に連結されていたため最後に読む。
import "./src/global";
